module.exports = __webpack_public_path__ + "static/media/accessory31.aa3983e4.webp";